import React, { useState, useEffect, Fragment } from 'react'
import './AddOrEditProductCategory.css';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';
import { addProductCategory, getProductCategories, updateProductCategory } from '../../services/http';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { getProductCategory } from '../../services/http';
import { handleMenuSelection, handleSubMenuSelection, reload } from '../../utils/utils';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import Loader from '../Loader/Loader';
import ProcessSpinner from '../ProcessSpinner/ProcessSpinner';



const AddOrEditProductCategory = (props) => {

    const { show, handleClose, idCategory, oldCategoryLabel, operationType } = props;

    const navigate = useNavigate();

    const id_product_category = useParams()
    const dispatch = useDispatch();
    const states = useSelector((state) => state, shallowEqual);



    // To populate the breadcrumb and update the sidebar menu
    useEffect(async () => {
        let type = operationType === "new" ? "Création" : "Modification"
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Paramètres", firstLevelLink: "/product-category", secondLevelText: "Catégorie Produit", secondLevelLink: "", thirdLevelText: type, thirdLevelLink: ""
            }
        });
        handleMenuSelection("settings", dispatch, states);
        handleSubMenuSelection("product-category", dispatch)
    }, [])


    const [categoryLabel, setCategoryLabel] = useState({ libelle: "" });

    const [displayLoader, setDisplayLoader] = useState(operationType == "new" ? false : true);
    const [processOngoing, setProcessOngoing] = useState(false)


    // const loadProductCategoryData = async() => {
    //     const resp = await getProductCategory(id_product_category)
    //     if(resp.response && resp.response.status !== 200){
    //          console.log("data error ", resp.response)
    //     } else {
    //         console.log("data data ", resp.data)

    //         let data_received = resp.data;
    //              setCategoryLabel({...categoryLabel, libelle: data_received.libelle})
    //     }

    // }

    // useEffect(()=> {
    //     loadProductCategoryData();
    //     console.log(id_product_category)
    // }, [id_product_category])

    const [showError, setShowError] = useState({
        libelle: false
    });
    const [errorMessage, setErrorMessage] = useState({
        libelle: ""
    })

    const handleChangeLabel = (e) => {
        var value = e.currentTarget.value;
        setCategoryLabel({ ...categoryLabel, libelle: value });
    }


    const handleAddProductCategory = async (type) => {
        setProcessOngoing(true)
        console.log("Here is category to add", categoryLabel)
        const reqdata = await addProductCategory(categoryLabel.libelle, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            setProcessOngoing(false)
            if (reqdata.response.status === 422) {
                let errorMsg = reqdata.response?.data.error["libelle"][0];
                console.log("Error Msg ", errorMsg)
                setShowError({ ...showError, libelle: true })
                setErrorMessage({ ...errorMessage, libelle: errorMsg })
            } else {
                console.log(reqdata.response?.data.error)
                toast.error(reqdata.response?.data.error, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } else {
            setProcessOngoing(false)
            console.log("Here we are")
            toast.success(`Nouvelle catégorie ${categoryLabel.libelle} ajoutée avec succès !`, {
                position: toast.POSITION.TOP_RIGHT
            });
            setCategoryLabel({ ...categoryLabel, libelle: "" })
            let response = await getProductCategories(states.userToken.access_token, 1, "");

            let response_copy = response.data?.data?.map(obj => ({ ...obj, showEdit: false, showDelete: false }))

            dispatch({
                type: "SET",
                key: "productCategoriesList",
                payload: response_copy,
            });
            if(type=="retourner") {navigate("/product-category")}

        }

    }

    const handleEditProductCategory = async () => {
        setProcessOngoing(true)
        const reqdata = await updateProductCategory(id_product_category, categoryLabel.libelle, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            setProcessOngoing(false)
            if (reqdata.response.status === 422) {
                let errorMsg = reqdata.response?.data.error["libelle"][0];
                console.log("Error Msg ", errorMsg)
                setShowError({ ...showError, libelle: true })
                setErrorMessage({ ...errorMessage, libelle: errorMsg })
            } else {
                console.log(reqdata.response?.data.error)
                toast.error(reqdata.response?.data.error, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } else {
            setProcessOngoing(false)
            toast.success(`Modification effectuée !`, {
                position: toast.POSITION.TOP_RIGHT
            });

            let response = await getProductCategories(states.userToken.access_token, 1, "");
            let response_copy = response?.data?.data.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
            dispatch({
                type: "SET",
                key: "productCategoriesList",
                payload: response_copy,
            });

            navigate("/product-category")

        }
    }


    useEffect(() => {
        if (categoryLabel.libelle != "") {
            setShowError({ ...showError, libelle: false })
        }
    }, [categoryLabel])


    useEffect(() => {
        if (operationType !== "new") {
            loadProductCategoryData();
        }

    }, [])

    const loadProductCategoryData = async () => {
        const resp = await getProductCategory(id_product_category, states.userToken.access_token)
        if (resp.response && resp.response.status !== 200) {
            console.log("data error ", resp.response)
        } else {
            console.log("data data produit", resp.data)
            setCategoryLabel({ ...categoryLabel, libelle: resp.data.libelle })
            setDisplayLoader(false)
        }
    }

    return (

        <>
            <div>
                <Navbar />
                <div className="main-container" id="container">
                    <Sidebar />

                    <div id="content" className="main-content">
                        <div className="layout-px-spacing m-auto"
                        // style={{paddingTop : "50%"}}
                        >

                            <div className="row layout-top-spacing">
                                <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                                </div>
                            </div>
                            {displayLoader == false ?
                                <div className="widget widget-content widget-content-area mx-auto">
                                    <div class="modal-header text-center py-2">
                                        <h5 className="">{operationType == "new" ? "Nouvelle Catégorie" : "Modifier Catégorie"}</h5>
                                        <button type="button" onClick={() => handleClose(idCategory)} class="close" data-dismiss="modal" aria-label="Close">
                                            {/* <span aria-hidden="true">&times;</span> */}
                                        </button>
                                    </div>
                                    <Modal.Body className="modal-body">
                                        <div class="simple-example w-90 mx-auto">
                                            <div class="form-group w-80 mx-auto row mb-4">
                                                <label for="libelle" class="col-sm-2 col-form-label col-form-label-sm text-dark required">Libellé</label>
                                                <div class="col-sm-10">
                                                    <input type="text" onChange={handleChangeLabel} className={showError.libelle == true ? "form-control custom-form-control  new-product-category-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={categoryLabel.libelle} required />
                                                    {showError.libelle === true && <span className="new-product-category-error-span">{errorMessage.libelle}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </Modal.Body>
                                    <div className="modal-footer">
                                        
                                        {processOngoing == false ? <Fragment>
                                        <button type="button" className="btn btn-primary ml-3"
                                            title={operationType == "new" ? "Ajouter et rester sur la page" : "Modifier"}
                                            onClick={operationType == "new" ? () => handleAddProductCategory("rester") : handleEditProductCategory}>{operationType == "new" ? "Ajouter et Nouveau" : "Modifier"}</button>
                                        {operationType == "new" &&
                                            <button type="button"
                                                title={"Ajouter et retourner à la liste"}
                                                className="btn btn-primary ml-3"
                                                onClick={() => handleAddProductCategory("retourner")}>
                                                Ajouter et Retourner</button>
                                        }
                                         </Fragment> : <ProcessSpinner />}
                                         <button className="btn ml-3" data-dismiss="modal" onClick={() => navigate("/product-category")}><i className="flaticon-cancel-12"></i> Retour</button>
                                    </div>
                                </div> :
                                <div style={{ marginTop: "25%" }}>
                                    <Loader />
                                </div>}
                        </div>

                    </div>
                </div>
            </div>


            {/* 
                <div className="new-product-category-custom-modal-content">
<div className="w-80 mx-auto">
                    <h5 className="modal-title py-3 text-left " id="exampleModalLabel">{operationType=="new" ? "Nouvelle Catégorie" : "Modifier Catégorie"}</h5>
</div>
                        <form className="simple-example">
                            <div className="form-row">
                                <div className="col-md-12 mb-4">
                                    <label for="fullName">Libellé</label>
                                    <input type="text" className={showError.libelle == true ? "form-control new-product-category-error-input w-80 mx-auto" : "form-control w-80 mx-auto"} onChange={handleChangeLabel} id="label" placeholder="" value={categoryLabel.libelle} required />
                                    {showError.libelle === true && <span className="new-product-category-error-span">{errorMessage.libelle}</span>}
                                </div>
                            </div>
                        </form>           
                    <div className="new-product-category-custom-modal-footer">
                        <button className="btn" data-dismiss="modal" onClick={handleBack}><i className="flaticon-cancel-12"></i> Retour</button>
                        <button type="button" className="btn btn-primary ml-3" onClick={operationType=="new" ? handleAddProductCategory : handleEditProductCategory}>{operationType=="new" ? "Ajouter" : "Modifier"}</button>
                    </div>
                </div> */}

        </>

    )
}

export default AddOrEditProductCategory